<template>
  <div class="base-section">
    <div class="hot-course section">
      <div class="section-title">
        热门课程
        <div class="bar" />
      </div>
      <div class="content">
        <div v-for="(item,index) in hotCourseList" :key="index" class="content-item" :class="{marginLeft30: index%2 === 1}">
          <img v-if="item.coverImg" :src="$urlPrefix + item.coverImg" alt="">
          <div v-else class="coverArea">
            <p>{{ item.specialTitle }}</p>
          </div>
          <div class="details">
            <div :style="{backgroundColor: $typeColorMapping[item.specialType]}">{{ $typeMapping[item.specialType] }}</div>
            <span class="title" @click="checkDetails(item.pkid, 'course')">{{ item.specialTitle }}</span>
            <br>
            <p>主讲人：{{ item.keynoteSpeaker }}</p>
            <span class="price-span">
              <template v-if="item.originPrice">
                <template v-if="item.preferentialPrice || item.preferentialPrice === 0">
                  <span class="old-price">￥{{ item.originPrice }}元/人</span>
                  <span>{{ item.preferentialPrice === 0 ? '免费' : '￥' + item.preferentialPrice + '元/人' }}</span>
                </template>
                <span v-else>￥{{ item.originPrice }}元/人</span>
              </template>
              <span v-else>免费</span>
            </span>
            <div class="check-details" @click="checkDetails(item.pkid, 'course')">查看详情</div>
          </div>
        </div>
      </div>
    </div>
    <div class="activity section">
      <div class="section-title">
        活动推荐
        <div class="bar" />
      </div>
      <div class="content">
        <div v-for="(item,index) in activityList" :key="index" class="content-item" :class="{marginLeft30: index%2 === 1}">
          <div v-if="item.process" class="enroll" :style="{backgroundColor: $processMapping[item.process].color}">{{ $processMapping[item.process].name }}</div>
          <img v-if="item.coverImg" :src="$urlPrefix + item.coverImg" alt="">
          <div v-else class="coverArea">
            <p>{{ item.activityTitle }}</p>
          </div>
          <div class="details">
            <div :style="{backgroundColor: $typeColorMapping[item.activityType]}">{{ $typeMapping[item.activityType] }}</div>
            <span class="title" @click="checkDetails(item.pkid, 'activity')">{{ item.activityTitle }}</span>
            <br>
            <p>开始时间：{{ item.startTime }}</p>
            <span class="price-span">
              <template v-if="item.originPrice">
                <template v-if="item.preferentialPrice || item.preferentialPrice === 0">
                  <span class="old-price">￥{{ item.originPrice }}元/人</span>
                  <span>{{ item.preferentialPrice === 0 ? '免费' : '￥' + item.preferentialPrice + '元/人' }}</span>
                </template>
                <span v-else>￥{{ item.originPrice }}元/人</span>
              </template>
              <span v-else>免费</span>
            </span>
            <div class="check-details" @click="checkDetails(item.pkid, 'activity')">查看详情</div>
          </div>
        </div>
      </div>
    </div>
    <div class="screen-area">
      <div class="left">
        <div class="screen-type-area">
          <div class="screen-type-row">
            主题:
            <span class="screen-type-item" :class="{on: screenParams.theme === '' || screenHover.theme === ''}" @click="screenParams.theme = ''">全部</span>
            <span
              v-for="(item, index) in screenTheme"
              :key="index"
              class="screen-type-item"
              :class="{on: screenParams.theme === item.value || screenHover.theme === item.value}"
              @mouseenter="screenHover.theme = item.value"
              @mouseleave="screenHover.theme = 'xxx'"
              @click="screenParams.theme = item.value"
            >
              {{ item.label }}
            </span>
          </div>
          <div class="screen-type-row">
            形式:
            <span class="screen-type-item" :class="{on: screenParams.form === '' || screenHover.form === ''}" @click="screenParams.form = ''">全部</span>
            <span
              v-for="(value, key) in screenForm"
              :key="key"
              class="screen-type-item"
              :class="{on: screenParams.form === key || screenHover.form === key}"
              @mouseenter="screenHover.form = key"
              @mouseleave="screenHover.form = 'xxx'"
              @click="screenParams.form = key"
            >
              {{ value }}
            </span>
          </div>
          <div class="screen-type-row">
            类型:
            <span class="screen-type-item" :class="{on: screenParams.type === '' || screenHover.type === ''}" @click="screenParams.type = ''">全部</span>
            <span
              v-for="(value, key) in screenType"
              :key="key"
              class="screen-type-item"
              :class="{on: screenParams.type === key || screenHover.type === key}"
              @mouseenter="screenHover.type = key"
              @mouseleave="screenHover.type = 'xxx'"
              @click="screenParams.type = key"
            >
              {{ value }}
            </span>
          </div>
        </div>

        <div class="screen-result">
          <div v-for="(item,index) in screenList" :key="index" class="content-item" :class="{marginLeft30: index%2 === 1}">
            <div v-if="item.process" class="enroll" :style="{backgroundColor: $processMapping[item.process].color}">{{ $processMapping[item.process].name }}</div>
            <img v-if="item.img" :src="$urlPrefix + item.img" alt="">
            <div v-else class="coverArea">
              <p>{{ item.title }}</p>
            </div>
            <div class="details">
              <div :style="{backgroundColor: $typeColorMapping[item.activityType]}">
                {{ $typeMapping[item.activityType] }}
              </div>
              <span class="title" @click="checkDetails(item.pkid, item.type)">{{ item.title }}</span>
              <br>
              <p v-if="item.type === 'activity'">活动时间：{{ item.startTime }}</p>
              <p v-else>主讲人：{{ item.keynoteSpeaker}} </p>
              <span class="price-span">
                <template v-if="item.originPrice">
                  <template v-if="item.preferentialPrice || item.preferentialPrice === 0">
                    <span class="old-price">￥{{ item.originPrice }}元/人</span>
                    <span>{{ item.preferentialPrice === 0 ? '免费' : '￥' + item.preferentialPrice + '元/人' }}</span>
                  </template>
                  <span v-else>￥{{ item.originPrice }}元/人</span>
                </template>
                <span v-else>免费</span>
              </span>
              <div class="check-details" @click="checkDetails(item.pkid, item.type)">查看详情</div>
            </div>
          </div>
        </div>
        <el-pagination
          background
          align="left"
          style="margin: 30px 30px"
          layout="total, prev, pager, next, jumper"
          :current-page="pageNumber"
          :page-sizes="[5, 10, 20, 30, 50]"
          :page-size="5"
          :total="totalCount"
          @current-change="handleCurrentChange"
        />
      </div>
      <div class="right">
        <div class="title">
          导师推荐
          <div class="bar"></div>
        </div>
        <div v-for="(item, index) in tutorList" :key="index" class="tutor-item">
          <div class="person-info">
            <img :src="item.headImg ? $urlPrefix + item.headImg : require('../../assets/img/defaultHead2.png')" alt="">
            <div class="info">
              <span class="title" @click="checkTutor(item.pkid)">{{ item.tutorName }}</span>
              <p class="detail">{{ item.tutorProfile }}</p>
            </div>
          </div>
          <ul>
            <li v-for="(item2, index2) in item.dataList" :key="index2" @click="checkDetails(item2.pkid, item2.type)">
              <p>{{ item2.title }}</p>
              <div class="list-item" :style="{backgroundColor: $typeColorMapping[item2.specialType]}">
                {{ $typeMapping[item2.specialType] }}
              </div>
            </li>
          </ul>
          <div class="check-tutor" @click="checkTutor(item.pkid)">查看详情</div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSection',
  data() {
    return {
      urlMapping: {
        'operation': '运维能力课',
        'product': '产品研习堂',
        'capital': '资本对接营'
      },
      pageNumber: 1,
      totalCount: 0,
      tutorList: [],
      activityList: [],
      hotCourseList: [],
      screenList: [],
      screenTheme: [],
      screenForm: [],
      screenType: [],
      screenParams: {
        theme: '',
        form: '',
        type: '',
        pageSize: 5
      },
      screenHover: {
        theme: '',
        form: '',
        type: ''
      }
    }
  },
  watch: {
    screenParams: {
      handler(val) {
        this.pageNumber = 1
        this.getData()
      },
      deep: true
    },
    $route: {
      handler(val) {
        this.screenParams = {
          theme: '',
          form: '',
          type: '',
          pageSize: 5,
          societyCode: val.name + '-moudle'
        }
        this.getBannerList(val.name)
        this.getOptions(val.name)
        this.getHotActivity(val.name)
        this.getHotCourse(val.name)
        this.getTutor(val.name)
      },
      immediate: true
    }
  },
  methods: {
    getBannerList(name) {
      this.$get('/front/index/banner', name).then(res => {
        if (res) {
          this.$emit('changeBannerList', res)
        }
      })
    },
    getHotActivity(name) {
      this.$get('/front/society/hotActivity', name).then(res => {
        if (res) {
          this.$emit('getActivityProcess', res)
          this.activityList = res
        }
      })
    },
    getHotCourse(name) {
      this.$get('/front/society/hotSpecialCourse', name).then(res => {
        if (res) {
          this.hotCourseList = res
        }
      })
    },
    getTutor(name) {
      this.$get('/front/tutor/tutorRecommend', name).then(res => {
        if (res) {
          this.tutorList = res
        }
      })
    },
    getOptions(name) {
      this.$get('/front/society/selectScreen', name).then(res => {
        if (res) {
          this.screenTheme = []
          Object.keys(res.theme).forEach(key => {
            this.screenTheme.push({
              label: res.theme[key],
              value: key
            })
          })
          if (name === 'product') {
            const temp = this.screenTheme[0]
            this.screenTheme[0] = this.screenTheme[1]
            this.screenTheme[1] = temp
          }
          this.screenTheme = [...this.screenTheme.filter(item => item.label !== '其他'), ...this.screenTheme.filter(item => item.label === '其他')]
          this.screenForm = res.form
          this.screenType = res.type
        }
      })
    },
    getData() {
      this.screenParams.pageNumber = this.pageNumber
      this.$post('/front/society/selectPage', this.screenParams).then(res => {
        if (res) {
          if (res.records.length > 0 && res.records[0].type === 'activity') {
            this.$emit('getActivityProcess', res.records)
          }
          this.screenList = res.records
          this.totalCount = res.total
        } else {
          this.screenList = []
          this.totalCount = 0
        }
      })
    },
    handleCurrentChange(val) {
      this.pageNumber = val
      this.getData()
    },
    checkTutor(pkid) {
      this.$router.push({
        path: '/tutorDetail',
        query: {
          pkid: pkid,
          pathList: JSON.stringify([
            {
              name: this.urlMapping[this.$route.name],
              path: this.$route.path
            }
          ])
        }
      })
    },
    checkDetails(pkid, type) {
      let toPath
      type === 'activity' ? toPath = '/activityDetail' : toPath = '/courseMain'
      this.$router.push({
        path: toPath,
        query: {
          pkid: pkid,
          pathList: JSON.stringify([
            {
              name: this.urlMapping[this.$route.name],
              path: this.$route.path
            }
          ])
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.base-section {
  width: 100%;
  margin: 0 auto;
  .content-item {
    position: relative;
    display: inline-block;
    width: 585px;
    height: 180px;
    margin-top: 30px;
    background: #FFFFFF;
    border-radius: 5px;
    padding: 15px 20px;
    box-sizing: border-box;
    overflow: hidden;
    .enroll {
      position: absolute;
      top: -31px;
      right: -31px;
      width: 63px;
      height: 63px;
      background-color: #0AC18F;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 109px;
      transform: rotate(45deg);
      z-index: 10;
    }
    img {
      display: inline-block;
      width: 210px;
      height: 150px;
      border-radius: 5px;
    }
    .details {
      display: inline-block;
      position: relative;
      width: 305px;
      height: 150px;
      margin-left: 30px;
      vertical-align: top;
      text-align: left;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
      font-size: 14px;
      div {
        display: inline-block;
        width: 80px;
        height: 24px;
        background: #F69F60;
        margin-right: 10px;
        border-radius: 5px;
        text-align: center;
        color: #FFFFFF;
      }
      .title {
        font-size: 16px;
        cursor: pointer;
      }
      .title:hover {
        color: #EA5504;
      }
      p {
        width: 100%;
        padding-top: 15px;
        color: #999999;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .price-span {
        position: absolute;
        left: 0;
        bottom: -5px;
        .old-price {
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          text-decoration: line-through;
          margin-right: 5px
        }
        span {
          color: #EF2727;
          font-size: 16px;
          font-weight: bold
        }
      }
      .check-details {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 108px;
        height: 30px;
        line-height: 30px;
        background: #EA5504;
        border-radius: 2px;
        text-align: center;
        cursor: pointer;
      }
      .check-details:hover {
        opacity: 0.9;
      }
    }
  }
  .content-item:hover {
    box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
  }
  .section {
    width: 100%;
    padding: 30px 0;
    background-color: #F6F6F6;
    margin: 0 auto;
    text-align: center;
    .section-title {
      width: 100%;
      height: 78px;
      font-size: 48px;
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      color: #333333;
      line-height: 48px;
    }
    .bar {
      width: 40px;
      height: 3px;
      background: #EA5504;
      margin: 15px auto 0 auto;
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      .marginLeft30 {
        margin-left: 30px;
      }
    }
  }
  .activity {
    background-color: #EFF0F0;
  }
  .screen-area {
    background-color: #F6F6F5;
    margin: 0 auto;
    text-align: center;
    padding: 50px 0;
    .left {
      display: inline-block;
      width: 850px;
      margin: 0 auto;
      vertical-align: top;
      .screen-type-area {
        width: 100%;
        .screen-type-row {
          width: 100%;
          height: 30px;
          margin-bottom: 30px;
          text-align: left;
          font-size: 22px;
          font-weight: 400;
          color: #333333;
          .screen-type-item {
            font-size: 18px;
            padding: 3px 10px;
            margin-right: 10px;
            cursor: pointer;
            border-radius: 3px;
          }
          .screen-type-item.on {
            background-color: #EA5504;
            color: #FFFFFF;
          }
        }
      }
      .screen-result {
        .content-item {
          width: 850px;
          margin-top: 0;
          margin-bottom: 30px;
          .details {
            width: 550px;
            padding-right: 20px;
            .check-details {
              top: 55px;
            }
          }
          .enroll {
            top: -45px;
            right: -45px;
            width: 90px;
            height: 90px;
            font-size: 15px;
            line-height: 150px;
          }
        }
      }
    }
    .right {
      display: inline-block;
      width: 300px;
      height: 500px;
      margin-left: 50px;
      .title {
        width: 100%;
        line-height: 40px;
        text-align: center;
        font-size: 48px;
        font-family: YouSheBiaoTiHei;
        font-weight: 400;
        color: #333333;
        .bar {
          width: 40px;
          height: 3px;
          margin: 20px auto 0 auto;
          background: #EA5504;
        }
      }
      .tutor-item {
        width: 300px;
        padding: 20px;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 5px;
        margin-top: 30px;
        .person-info {
          width: 260px;
          height: 106px;
          border-bottom: 2px solid #EDEDED;
          img {
            display: inline-block;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            vertical-align: top;
          }
          .info {
            display: inline-block;
            width: 160px;
            line-height: 30px;
            margin-left: 20px;
            text-align: left;
            .title {
              line-height: 20px;
              font-size: 24px;
              font-family: "Microsoft YaHei";
              font-weight: bold;
              color: #333333;
              margin-bottom: 10px;
              cursor: pointer;
            }
            .title:hover {
              color: #EA5504;
            }
            .detail {
              width: 170px;
              display: inline-block;
              line-height: 22px;
              text-align: left;
              color: #999999;
            }
          }
        }
        ul {
          margin-left: 20px;
          li {
            cursor: pointer;
            text-align: left;
            list-style-type: square;
            margin-top: 20px;
            color: #333333;
            p {
              display: inline-block;
              max-width: 190px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              vertical-align: top;
            }
            .list-item {
              display: inline-block;
              width: 40px;
              height: 18px;
              line-height: 18px;
              border-radius: 5px;
              font-size: 12px;
              text-align: center;
              color: #FFFFFF;
              margin: 3px 0 0 10px;
              vertical-align: top;
            }
          }
          li:hover {
            color: #EA5504;
          }
        }
        .check-tutor {
          width: 108px;
          height: 30px;
          line-height: 30px;
          margin: 20px auto 0 auto;
          background-color: #EA5504;;
          color: #FFFFFF;
          text-align: center;
          border-radius: 3px;
          cursor: pointer;
          font-size: 14px;
        }
        .check-tutor:hover {
          opacity: 0.8;
        }
      }
      .tutor-item:hover {
        box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
      }

    }
  }
}
</style>
